import React from 'react';
import { parseScopesForDisplay } from '../utility/scopes';

interface Props {
  scopes: string[] | undefined;
  /** Collapse to "N actions" past this many granular badges (default 3). */
  max?: number;
}

/** Renders a key's granted scopes as compact chips. Used on the API-key list. */
const ScopeBadges: React.FC<Props> = ({ scopes, max = 3 }) => {
  const badges = parseScopesForDisplay(scopes);
  const shown = badges.slice(0, max);
  const hidden = badges.length - shown.length;

  return (
    <span className="scope-badges">
      {shown.map((b) => (
        <span key={b.token} className={`scope-badge kind-${b.kind}`}>
          {b.label}
        </span>
      ))}
      {hidden > 0 && (
        <span className="scope-badge kind-more" title={badges.map((b) => b.token).join(', ')}>
          +{hidden} more
        </span>
      )}
    </span>
  );
};

export default ScopeBadges;
